import { ExtendedBasketItem } from '@epicuro-next/state/basket-state';
import { ProductSource } from '@epicuro-next/state/config-strip-state';
import { createAction, props } from '@ngrx/store';

export const addItemsToBasketTracking = createAction(
  '[Basket] Add items to tracking',
  props<{
    addedItems: ExtendedBasketItem[];
    productSource: ProductSource;
    mappedProductSource: unknown;
  }>(),
);
